import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import {
  deleteActExtraEstudiantesAction,
  setActivoActExtraEstudiantesAction,
} from '../ActExtraEstudiantesAction';
import { ALL_ACTEXTRA_ESTUDIANTES } from '../ActExtraEstudiantesReducer';
import CardActExtraEstudiante from './CardActExtraEstudiante';

const ListadoActExtraEstudiantes = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );

  const actExtraEstudiantesStore = Redux.useSelector(
    (state) => state.actExtraEstudiantes,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      dispatch({
        type: ALL_ACTEXTRA_ESTUDIANTES,
        payload: {
          data: actividadesExtrasStore.activo.estudiantes,
        },
      });
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    async function fetchData() {
      dispatch({
        type: ALL_ACTEXTRA_ESTUDIANTES,
        payload: {
          data: actividadesExtrasStore.activo.estudiantes,
        },
      });
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actividadesExtrasStore.activo]);

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteActExtraEstudiantesAction(
      { dispatch, notify },
      actividadesExtrasStore.activo.id,
      actExtraEstudiantesStore.activo.id,
      actExtraEstudiantesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={actExtraEstudiantesStore.loadingAll || loadingDelete}
        />
      </Grid>
      <Grid item md={12}>
        <Grid container spacing={2}>
          {actExtraEstudiantesStore.all.length > 0 &&
            actExtraEstudiantesStore.all.map((el) => {
              return (
                <Grid item md={3}>
                  <CardActExtraEstudiante
                    data={el}
                    idActividadExtra={actividadesExtrasStore.activo.id}
                    onDelete={() => {
                      setActivoActExtraEstudiantesAction(dispatch, el);
                      setOpenModalDelete(true);
                    }}
                    estudiante={el.estudiante}
                  />
                </Grid>
              );
            })}
        </Grid>
      </Grid>
      {actExtraEstudiantesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {actExtraEstudiantesStore.activo.estudiante.usuario.perfil.tipoDni}-
            {actExtraEstudiantesStore.activo.estudiante.usuario.perfil.dni}
            <br />
            {actExtraEstudiantesStore.activo.estudiante.usuario.perfil.pnombre}
            {
              actExtraEstudiantesStore.activo.estudiante.usuario.perfil
                .papellido
            }
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoActExtraEstudiantes;
